var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticClass:"akkurate-green-btn text-white btn-size",attrs:{"type":"submit","disabled":_vm.isSaving}},[_c('font-awesome-icon',{staticClass:"me-2",attrs:{"icon":['fas', 'save']}}),_vm._v(" Save ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }